function toggleCartPopup() {
  let button = $('.cart-popup__close');
  button.on('click', function() {
    $(this).closest('.cart-popup__product').remove();
  });
}
toggleCartPopup();